import { Fragment, useEffect, useState } from "react";
import smsService from "./../../services/smsService";

const SMSBalance = () => {
  const [smsBalance, setSmsBalance] = useState("");

  //(a) Get sms balance
  const fetchSMSBalance = async () => {
    try {
      let smsBalanceStr = await smsService.getSMSBalance();
      console.log("smsBalance : " + smsBalance);
      let balanceObj = JSON.parse(smsBalanceStr);
      setSmsBalance(balanceObj?.balance);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchSMSBalance();
  }, []);

  return (
    <Fragment>
      <div
        className="card "
        style={{
          marginTop: "10px",
          marginBottom: "10px",
          padding: "10px",
          minHeight: "400px",
        }}
      >
        <div className="card-body card-body-padding-less">
          <div style={{ float: "left", fontSize: "22px" }}>
            Remaining SMS Balance : <b> {smsBalance} TK</b>
          </div>
          <div style={{ clear: "both" }}></div>
        </div>
      </div>
    </Fragment>
  );
};

export default SMSBalance;
